import React from "react";
import { Container, Typography, Box, Paper, Button, TextField, Alert } from "@mui/material";

const Contact: React.FC = () => {
  const [formData, setFormData] = React.useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = React.useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("Sua mensagem foi enviada com sucesso!");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <Container maxWidth="md" sx={{ mt: 8, textAlign: "center" }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography component="h1" variant="h4" gutterBottom>
          Fale Conosco
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Se você tiver alguma dúvida, sugestão ou feedback, por favor, entre em contato. Responderemos o mais breve possível.
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField fullWidth margin="normal" label="Seu Nome" name="name" value={formData.name} onChange={handleChange} required />
          <TextField
            fullWidth
            margin="normal"
            label="Seu Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <TextField
            fullWidth
            margin="normal"
            label="Sua Mensagem"
            name="message"
            multiline
            rows={4}
            value={formData.message}
            onChange={handleChange}
            required
          />
          <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
            Enviar Mensagem
          </Button>
          {status && (
            <Alert severity="success" sx={{ mt: 2 }}>
              {status}
            </Alert>
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default Contact;
